import { useGetOrCreateLocationsMutation } from "@api/graphql/generated/generated-types";
import { useErrorToast } from "@src/common/hooks/useErrorToast";

export const useGooglePlaceLocation = () => {
  const [getOrCreateLocationsMutation] = useGetOrCreateLocationsMutation();
  const showError = useErrorToast();

  const getLocationFromPlaceId = (placeId: string) => {
    return getOrCreateLocationsMutation({
      variables: {
        googlePlaceIds: [placeId]
      },
    })
      .then((response) => {
        const location = response.data?.getOrCreateLocations?.[0];

        if (!location) {
          throw new Error("Location not found");
        }

        return {
          lngLat: location.location?.lngLat,
          city: location.location?.city,
          state: location.location?.state,
          country: location.location?.country,
          location: location,
        };
      })
      .catch((error) => {
        showError(error);
        return null;
      });
  };

  return { getLocationFromPlaceId };
};
